import React , {useState , useEffect} from 'react';
import {  doc, getDoc , db  , setDoc  , query , collection , where , getDocs , deleteDoc} from '../firebase';
import { useParams } from 'react-router-dom';
import {  Carousel } from 'react-bootstrap';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import SideFooter from '../components/SideFooter';
import Footer from '../components/Footer';


const SingleExperince = () => {

  let { experinceId } = useParams();

  const [packageObject , setPackageObject] = useState({});

  const [loading , setLoading] = useState(false);


  useEffect(() => {

    window.scrollTo(0,0);
    
    const getProductsFromFirestore = async () => {
      const docRef = doc(db, "experiences", experinceId );
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
 
  setPackageObject(docSnap.data());
} else {

  setPackageObject(null)
}


    }
    getProductsFromFirestore();

  } , []);

  useEffect(() => {

    setLoading(true);

    setTimeout(() => {
       setLoading(false);
    } , 600)

 } , [])

 const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

 const [userAddedPackage , setUserAddedPackage] = useState(true);

 const [foundedCartPackage , setFoundedCartPackage] = useState('');




 useEffect(() => {

   const checkIfPackagedAdded = async () => {
     const q = query(collection(db, `cart ${user.id}`), where("id", "==", experinceId )  );
      
     const querySnapshot = await getDocs(q);
   
     const packagesDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';
 
  setFoundedCartPackage(packagesDataArray);
    
     if (packagesDataArray.length === 0 ) {
       setUserAddedPackage(false);
     }
   }

   checkIfPackagedAdded();


} , [userAddedPackage]);

 
const makeid = (length) =>  {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
charactersLength));
 }
 return result;
}

const addCartToDb = async () => {

  setUserAddedPackage(!userAddedPackage);

  const cart = await setDoc(doc(db, `cart ${user.id}`, makeid(20)), {
    name : packageObject.experince_name,
    image: packageObject.experince_photos[0],
    price: packageObject.experince_price,
    service_provider: 'Tourist Compass',
    description : packageObject.experince_desc,
    status: 'wait-payment',
    id: experinceId
  
    
   
    });

}

const removeCartFromDb = async () => { 
  setUserAddedPackage(!userAddedPackage);
  await deleteDoc(doc(db, `cart ${user.id}`, foundedCartPackage[0].id ));

}

  



  return (
    <div className='main_homepage ' >


  <NavbarHome />

    <div className="container-mid">

    <div className='single_main_package ' >
    

    <div className="grid_single_package single_package_div ">

      <div className="package_image">

      <Carousel controls={false} pause={false} className="bg-white mt-2" style={{width:'100%',height:'240px'}}>
                        {
                            packageObject.experince_photos &&  packageObject.experince_photos.map(function(item,i){
                                return <Carousel.Item key={i} interval={3000} className="p-0 text-end hand" style={{width:'100%',height:'240px'}}>
                                    <img src={item} className="" style={{objectFit:'cover',objectPosition:'center',width:'100%',height:'240px'}} />
                                </Carousel.Item>
                            })
                        }
                    </Carousel>

  

      </div>
      <div className="package_info">

      <h1 className="headline_location"> { packageObject ? packageObject.experince_name : '' } </h1>

      <button className="btn_category mt-1"> 
    { packageObject ? packageObject.experince_location : '' } 
     </button>
  

      <p className="main_para mt-1"> 
      { packageObject ? packageObject.experince_desc : '' } 
       </p>

     

              <button className="mt-1 btn_shopping w-100"> السعر : {packageObject ? packageObject.experince_price : ''} ريال </button>

              {userAddedPackage ? (
      <div className='' >
      <button  className="mt-1 btn_shopping mx-2 bg_red w-100" onClick={() => removeCartFromDb() }  > ❌ الغاء   </button> 
                <div className="mt-1"></div>
      <button  className="btn_shopping bg_green w-100"  > ✅ تم الحجز  </button> 
    
      </div>
    
    ) : (
      <div className="w-100" onClick={() => addCartToDb() } >
      <button className="mt-1 btn_shopping bg_green w-100"  > اضافة الى السلة </button>
      </div>

     
    )}

  

      </div>

    </div>



    </div>

  <div className="section experinces_about_section">

  <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">   نظرة عامة </h1>
    </div>

    <div className="mt-2 the_about_content">
        <p className="main_para">  {packageObject ? packageObject.experince_overview : '' } </p>
    </div>

  </div>

  <div className="section experinces_moreabout_section">

  <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">    التفاصيل </h1>
    </div>

    <div className="mt-2  the_about_content">
        <p className="main_para"> { packageObject ? packageObject.experince_desc : '' } </p>
    </div>

  </div>

    <div className="package_section section">

    <div className="d-flex-c text-right ">
    
    <div className="info_box"></div>
    <h1 className="main_headline">   الصور </h1>
    </div>
      

<div className="grid_photos_area mt-2">

        {packageObject.experince_photos && packageObject.experince_photos.map((item) => (
            <div className="single_package_img">
    <img  src={item} alt="" />
  
</div>
        )) }



</div>

    </div>


    <div className="place_sections mt-4 text-right package_section">

    <div className="d-flex-c text-right mb-2">
    
    <div className="info_box"></div>
    <h1 className="main_headline">     المنطقة : {packageObject ? packageObject.experince_location : ''} </h1>
    </div>
       
        <div className="mt-1"></div>
        
        {packageObject ? (
          <div className="flex-col">
          <iframe className='iframe_responsive' src={packageObject.experince_map}  style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>

        ) : ''}


        

   

        </div>

    </div>



        
    <SideFooter />       
    <Footer />       


    </div>
  
  )
}

export default SingleExperince